import React from 'react'
import PropTypes from 'prop-types'
import emitOnClick from '@cred/react-analytics/hoc/emitOnClick'
import withCtaClickEvent from '@cred/react-analytics/hoc/withCtaClickEvent'
import emitGAOnClick from '@cred/shared/hoc/emitGAOnClick'
import withNofollow from 'components/hocs/with-nofollow'
import { compose } from 'redux'
import { Text } from '@cred/react-text'
import { SubmitButton as Button } from '@cred/react-button'
import styles from './styles.scss'

const MortgagesSubmitButton = ({ loading, disabled, hasIcon, error, children, ...props }) => {
  const { formData } = props,
    errors = formData && (formData.syncErrors || formData.asyncErrors),
    _disabled = disabled
      || !!(errors && Object.keys(errors).length)
      || loading
      || !!(formData && formData.asyncValidating)

  return (
    <>
      <Button {...props} disabled={_disabled}>
        {children}{' '}
        {loading ? (
          <i className={[styles.loading, 'cred-icon', 'icon-cached'].join(' ')} />
        ) : (
          hasIcon && <i className="cred-icon icon-chevron-right" />
        )}
      </Button>
      <Text type="caption" className={[styles.errorMessage, 'mt-8'].join(' ')}>
        {error}
      </Text>
    </>
  )
}

MortgagesSubmitButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array]).isRequired,
  formData: PropTypes.shape({
    asyncErrors: PropTypes.object,
    syncErrors: PropTypes.object,
    asyncValidating: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  }),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  hasIcon: PropTypes.bool,
}

MortgagesSubmitButton.defaultProps = {
  formData: null,
  loading: false,
  disabled: false,
  hasIcon: true,
  error: '',
}

export { MortgagesSubmitButton }
export default compose(
  withCtaClickEvent,
  emitOnClick,
  emitGAOnClick,
  withNofollow,
)(MortgagesSubmitButton)
